<template>
  <div>
    <!-- Início radialGradient pelo site -->
    <div
      v-if="!$vuetify.breakpoint.smAndDown"
      class="radialGradientRight"
    ></div>
    <div
      class="radialGradientLeft"
      :style="{
        top: $vuetify.breakpoint.smAndDown && '900px',
      }"
    ></div>
    <!-- Fim radialGradient pelo site -->

    <v-col class="pa-0">
      <!-- Vídeo principal -->
      <div
        :class="$vuetify.breakpoint.smAndDown ? 'videoBlurMobile' : 'videoBlur'"
        style="height: 30vh;"
      >
        <v-skeleton-loader
          v-if="!videoLoaded"
          type="image"
          style="height: 30vh;"
        ></v-skeleton-loader>
        <video
          v-show="videoLoaded"
          width="100%"
          height="100%"
          autoplay
          muted
          loop
          webkit-playsinline
          playsinline
          style="object-fit: cover;"
          @canplaythrough="() => games && (videoLoaded = true)"
        >
          <source
            src="https://dozr8la71aog.cloudfront.net/videos/pragmaticplay/PRAGMATIC+PLAY+TURNS+UP+THE+HEAT+IN+STRIKING+HOT+5%E2%84%A2.mp4"
            type="video/mp4"
          />
          <source
            src="https://dozr8la71aog.cloudfront.net/videos/pragmaticplay/PRAGMATIC+PLAY+SEEKS+HEAVENLY+FAVOUR+IN+QUEEN+OF+GODS%E2%84%A2.mp4"
            type="video/mp4"
          />
          <source
            src="https://dozr8la71aog.cloudfront.net/videos/pragmaticplay/6300x+Bet+Win+-+Buffalo+King+-+Pragmatic+Play.mp4"
            type="video/mp4"
          />
        </video>
      </div>

      <!-- Menu de categorias -->
      <MenuCategories
        :style="{
          position: 'sticky',
          top: $vuetify.breakpoint.mdAndDown ? '-2px' : '62px',
          'z-index': 2,
        }"
        @spacemanGame="gameClicked(spaceman, false)"
        @goGamesCategory="goGamesCategory"
      />

      <!-- Loading -->
      <v-progress-linear
        indeterminate
        absolute
        :active="loading"
      ></v-progress-linear>

      <v-container>
        <v-col
          :style="{
            width: !$vuetify.breakpoint.mdAndDown && '80%',
          }"
          class="mx-auto pa-0"
        >
          <!-- Filtro dos jogos pelo nome -->
          <div class="mx-auto">
            <v-autocomplete
              v-model="gameSelected"
              :items="gameList.all"
              :label="$t('searchByGame')"
              item-text="nome_jogo"
              prepend-icon="mdi-magnify"
              background-color="transparent"
              :dense="$vuetify.breakpoint.smAndDown"
              hide-no-data
              filled
              clearable
              return-object
              @blur="clearable()"
              @click:clear="clearable()"
            >
              <template v-slot:item="{ item }">
                <v-list-item-avatar class="colorDominant">
                  <v-img
                    :src="
                      `${gameAPI}/game_pic/rec/325/${item.id_game_simple}.png`
                    "
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    v-text="item.nome_jogo"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    v-text="item.category_name_pt"
                  ></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    color="primary"
                    small
                    outlined
                    @click="gameClicked(item, false)"
                    style="
                      background-color: transparent;
                      border-radius: 8px;
                      border-width: 2px;
                    "
                  >
                    <v-icon>
                      mdi-play
                    </v-icon>
                    <div :class="$vuetify.breakpoint.smAndDown && 'd-none'">
                      {{ $t("play") }}
                    </div>
                  </v-btn>
                </v-list-item-action>
              </template>
            </v-autocomplete>
          </div>

          <!-- Spaceman -->
          <div
            class="pa-0"
            v-if="showSpaceman && !this.$isAgent() && casino == '2'"
          >
            <v-img
              :src="
                $vuetify.breakpoint.smAndDown ? SpacemanMobile : SpacemanDesktop
              "
              max-width="100%"
              :max-height="$vuetify.breakpoint.xs ? '120' : '330'"
              :height="$vuetify.breakpoint.xs ? '120' : '330'"
              @load="spacemanImageLoaded = true"
              position="center left"
              style="border-radius: 8px;"
            >
              <v-skeleton-loader
                v-if="!spacemanImageLoaded"
                type="image"
                :style="{
                  height: $vuetify.breakpoint.smAndDown ? '100px' : '330px',
                }"
              ></v-skeleton-loader>
              <div
                class="d-flex flex-column"
                v-if="spacemanImageLoaded"
                :style="{
                  position: 'absolute',
                  right: $vuetify.breakpoint.smAndDown ? '8px' : '24px',
                  bottom: $vuetify.breakpoint.smAndDown ? '8px' : '24px',
                }"
              >
                <v-btn
                  color="primary"
                  :small="$vuetify.breakpoint.smAndDown"
                  style="border-radius: 8px;"
                  @click="gameClicked(spaceman, false)"
                >
                  {{ $t("play") }}
                </v-btn>
                <v-btn
                  color="primary"
                  :small="$vuetify.breakpoint.smAndDown"
                  outlined
                  :class="$vuetify.breakpoint.smAndDown ? 'mt-1' : 'mt-3'"
                  style="
                    background-color: black;
                    border-radius: 8px;
                    border-width: 2px;
                    opacity: 0.8;
                  "
                  @click="gameClicked(spaceman, true)"
                >
                  DEMO
                </v-btn>
              </div>
            </v-img>
          </div>

          <NoActiveGames class="text-center" v-if="noActiveGames" />

          <div v-else-if="gamesLoaded" class="mt-4 px-4">
            <div
              v-for="(category, categoryIndex) in getGameList"
              :key="categoryIndex"
              class="row d-flex justify-start"
              :class="$vuetify.breakpoint.smAndDown ? 'mt-0' : 'pt-14'"
            >
              <!-- Categoria SLOTS -->
              <div
                class="col pa-0"
                :class="$vuetify.breakpoint.smAndDown && 'mt-4 mb-8'"
                v-if="
                  category.category_name === 'Slots' &&
                    category.items.length > 0
                "
              >
                <div class="d-flex justify-space-between align-end mb-3">
                  <div
                    :class="
                      $vuetify.breakpoint.smAndDown ? 'text-h6' : 'text-h5'
                    "
                    style="filter: blur(0)"
                  >
                    Slots
                  </div>
                  <div style="filter: blur(0)">
                    <v-hover v-slot="{ hover }">
                      <v-btn
                        text
                        :color="hover ? 'primary' : ''"
                        :small="$vuetify.breakpoint.smAndDown"
                        class="px-2"
                        :class="
                          $vuetify.breakpoint.smAndDown
                            ? 'caption'
                            : 'subtitle-1'
                        "
                        @click="goGamesCategory('Slots', true)"
                      >
                        {{ $t("seeAllGamesCategory") }}
                      </v-btn>
                    </v-hover>
                  </div>
                </div>
                <!-- Início SwiperJS Coverflow effect component -->
                <div class="swiper coverflowSwiper">
                  <div class="swiper-wrapper">
                    <div
                      v-for="(game, index) in category.items"
                      :key="index"
                      class="swiper-slide"
                      :class="$vuetify.breakpoint.smAndDown && 'mx-0'"
                      :style="{
                        width: $vuetify.breakpoint.smAndDown
                          ? '170px'
                          : '330px',
                      }"
                    >
                      <div
                        class="transparent v-card v-sheet theme--dark elevation-0"
                        :width="$vuetify.breakpoint.smAndDown ? 150 : 330"
                        elevation="0"
                      >
                        <v-hover v-slot="{ hover }">
                          <div
                            class="v-image v-responsive theme--dark"
                            :class="
                              index + 1 === category.items.length ? 'mr-2' : ''
                            "
                            :style="{
                              'max-width': $vuetify.breakpoint.smAndDown
                                ? '150px'
                                : '330px',
                              'border-radius': '8px',
                            }"
                          >
                            <div
                              class="v-responsive__sizer"
                              style="padding-bottom: 72%;"
                            ></div>
                            <img
                              class="v-image__image v-image__image--cover"
                              :src="
                                `${gameAPI}/game_pic/rec/325/${game.id_game_simple}.png`
                              "
                              :style="{
                                'background-position': 'center center',
                              }"
                              @load="game.imageLoaded = true"
                            />
                            <div
                              class="v-responsive__content"
                              style="width: 325px;"
                            ></div>
                            <v-skeleton-loader
                              v-if="!game.imageLoaded"
                              type="image"
                              :style="{
                                height: $vuetify.breakpoint.smAndDown
                                  ? '100px'
                                  : '250px',
                              }"
                            >
                            </v-skeleton-loader>
                            <v-overlay
                              opacity="0.7"
                              absolute
                              v-if="hover && game.imageLoaded"
                            >
                              <div class="d-flex flex-column">
                                <v-btn
                                  color="primary"
                                  :small="$vuetify.breakpoint.smAndDown"
                                  style="border-radius: 8px;"
                                  @click="gameClicked(game, false)"
                                >
                                  {{ $t("play") }}
                                </v-btn>
                                <v-btn
                                  v-if="game.id_tipo !== 'lg'"
                                  color="primary"
                                  outlined
                                  :small="$vuetify.breakpoint.smAndDown"
                                  :class="
                                    $vuetify.breakpoint.smAndDown
                                      ? 'mt-2'
                                      : 'mt-3'
                                  "
                                  style="
                                    background-color: black;
                                    border-radius: 8px;
                                    border-width: 2px;
                                    opacity: 0.8;
                                  "
                                  @click="gameClicked(game, true)"
                                >
                                  DEMO
                                </v-btn>
                              </div>
                            </v-overlay>
                          </div>
                        </v-hover>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-button-prev" style="content: ''">
                    <v-icon
                      class="primary"
                      style="border-radius: 2rem;"
                      :size="$vuetify.breakpoint.smAndDown ? 32 : 40"
                    >
                      mdi-chevron-left
                    </v-icon>
                  </div>
                  <div class="swiper-button-next">
                    <v-icon
                      class="primary"
                      style="border-radius: 2rem;"
                      :size="$vuetify.breakpoint.smAndDown ? 32 : 40"
                    >
                      mdi-chevron-right
                    </v-icon>
                  </div>
                </div>
                <!-- Fim SwiperJS Coverflow effect component -->
              </div>

              <!-- Restante das categorias -->
              <CategorySlider
                v-else
                :data="category"
                @gameClicked="gameClicked"
                @goGamesCategory="goGamesCategory"
              />
            </div>
          </div>

          <v-row class="pt-2" v-else-if="!gamesLoaded" v-for="n in 10" :key="n">
            <v-col v-for="i in skeletonPerCol" :key="i">
              <v-skeleton-loader type="image" cols="4" md="4" />
            </v-col>
          </v-row>
        </v-col>
      </v-container>
    </v-col>

    <v-dialog max-width="600" v-model="notLoggedDialog">
      <v-card flat class="mx-auto colorDominant" max-width="600">
        <v-toolbar flat tile class="colorDominant">
          <v-btn icon @click="closeNotLoggedDialog()"
            ><v-icon>mdi-close</v-icon></v-btn
          >
          <span class="font-weight-black title ml-6 py-4"></span>
        </v-toolbar>
        <v-card-text
          class="text-center headline font-weight-light px-10 mt-4 pb-10"
        >
          <div>
            <v-icon class="dice" style="font-size: 80px"
              >mdi-dice-{{ Math.ceil(Math.random() * 5) + 1 }}</v-icon
            >
          </div>
          <div class="mt-3">
            <h6 class="white--text">
              {{ $t("toPlayInTheCasinoRegistorOrLogin") }}
            </h6>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="py-4">
          <v-spacer></v-spacer>
          <div id="dialogRegisterBtn" @click.capture="closeNotLoggedDialog()">
            <DialogRegister
              :urlRedirect="
                `/casino/game/${currentGame.id_game_simple}/${isFreeGame}`
              "
            />
          </div>
          <div id="loginBtn" @click.capture="closeNotLoggedDialog()">
            <Login
              :urlRedirect="
                `/casino/game/${currentGame.id_game_simple}/${isFreeGame}`
              "
            />
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  startSwiper,
  mountCoverflowSwiper,
  finishSwiper,
} from "@/util/coverflowSwiperCasino";
import casino from "@/plugins/plugin-casino";
import Login from "@/components/login/dialog.vue";
import DialogRegister from "@/views/home/register/dialog-register";
import CategorySlider from "./CategorySlider";
import NoActiveGames from "./NoActiveGames";
import SpacemanDesktop from "./spaceman-banner.jpg";
import SpacemanMobile from "./spaceman-banner.jpg";
import MenuCategories from "./MenuCategories.vue";

export default {
  name: "home-casino",
  components: {
    Login,
    DialogRegister,
    CategorySlider,
    NoActiveGames,
    MenuCategories,
  },
  data: () => ({
    spacemanImageLoaded: false,
    gameList: [],
    gameAPI: "https://api.prerelease-env.biz",
    fullGameAPI:
      "https://api.prerelease-env.biz/IntegrationService/v3/http/CasinoGameAPI",
    gameDefaultURL: "https://sga.prerelease-env.biz/gs2c/playGame.do?",
    freeGamesURL: "https://demogamesfree.pragmaticplay.net/gs2c/openGame.do?",
    currentGame: {},
    isFreeGame: false,
    externalPlayerID: "testPlayer",
    playerID: "",
    notLoggedDialog: false,
    tab: 0,
    loading: true,
    search: "",
    spaceman: { id_game_simple: "1301", nome_jogo: "Spaceman", id_tipo: "lg" },
    gamesLoaded: false,
    SpacemanDesktop,
    SpacemanMobile,
    games: [],
    spacemanExists: false,
    noActiveGames: false,
    gameSelected: null,
    videoLoaded: false,
  }),
  // Adicionando CDN do Swiper no head do site - tem que ser no created para
  // dar tempo de iniciar o cdn do swiper até o tempo de montar o swiper
  created() {
    startSwiper();

    // Caso seja clicado no Spaceman no leftMenu sem estar logado, virá para casino
    // para fazer login e ser redirecionado para o jogo
    // Foi colocado no created porque a url é modificada (tirando o gameSearch) após montar a page
    if (this.$route.query.gameSearch == "spaceman") {
      this.gameClicked(this.spaceman, false);
    }
  },
  async mounted() {
    const games = await casino.getActiveSlotGames().catch(() => {
      this.noActiveGames = true;
    });

    // Verifica se existe spaceman na listagem dos jogos
    games.forEach((game) => {
      game["id_game_simple"] = game.id_game_provedor.split("-")[1];
      if (game.id_game_simple == "1301") {
        this.spacemanExists = true;
      }
    });

    // Gera recursivamente objeto cujos atributos são as listas dos jogos
    //  de cada vertical (aba) do cassino
    this.gameList = games.reduce((accumulator, current) => {
      if (
        current.id_tipo === "bc" ||
        current.id_tipo === "bj" ||
        current.id_tipo === "rl"
      ) {
        current.id_tipo = "tg";
        current.category_name_en = "Table Games";
      }

      accumulator["all"] = [...(accumulator["all"] || []), current];
      accumulator[current.category_name_en] = [
        ...(accumulator[current.category_name_en] || []),
        current,
      ];
      return accumulator;
    }, {});

    this.groupAndOrderGamesByCategory();

    // Guarda jogo aberto quando tentativa de jogar sem logar foi realizada
    // para que o site redirecione automaticamente pra ele quando o user logar
    if (this.$route.params.openLoginDialog) {
      this.notLoggedDialog = true;
      this.currentGame = games.find(
        (el) => el.id_game_simple === this.$route.params.redirectedGameName
      );
    }

    // Pesquisa um Jogo Passado por Query (gameSearch):
    if (this.$route.query.gameSearch) {
      this.search = this.$route.query.gameSearch;
    }

    // Montando instância do Swiper
    mountCoverflowSwiper();

    this.loading = false;
  },
  beforeDestroy() {
    // Removendo CDN do Swiper no head do site
    finishSwiper();
  },
  methods: {
    // Inicializa jogo clicado
    async gameClicked(game, isFreeGame) {
      if (this.$store.state.logged.status) {
        this.$router.push({
          path: `/casino/game/${game.id_game_simple}/${isFreeGame}`,
        });
        return 0;
      }
      this.currentGame = game;
      this.isFreeGame = isFreeGame;
      this.notLoggedDialog = true;
    },
    closeNotLoggedDialog() {
      this.notLoggedDialog = false;
    },
    groupAndOrderGamesByCategory() {
      let slotsGames = [];
      let liveGames = [];
      let jackpotGames = [];
      let scratchGames = [];
      let tableGames = [];
      // let baccaratGames = [];
      // let blackjackGames = [];
      // let rouletteGames = [];
      // let outrosGames = [];

      for (let item in this.gameList) {
        if (item == "Video Slots" || item == "Classic Slots") {
          slotsGames.push(...this.gameList[item]);
        } else if (item == "Live games") {
          liveGames.push(
            ...this.gameList[item].filter(
              (game) =>
                game.id_game != "1301" &&
                game.id_game != "114" &&
                game.id_game != "302"
            )
          );
        } else if (item == "Jackpot") {
          jackpotGames.push(...this.gameList[item]);
        } else if (item == "Scratch card") {
          scratchGames.push(...this.gameList[item]);
        } else if (item == "Table Games") {
          tableGames.push(...this.gameList[item]);
        }

        //  else if (item == "Baccarat" || item == "Baccarat New") {
        //   baccaratGames.push(...this.gameList[item]);
        // } else if (item == "Blackjack") {
        //   blackjackGames.push(...this.gameList[item]);
        // } else if (item == "Roulette") {
        //   rouletteGames.push(...this.gameList[item]);
        // } else if (item == "Outros") {
        //   outrosGames.push(...this.gameList[item]);
        // }
      }

      const slotCategory = {
        category_name: "Slots",
        items: slotsGames,
      };

      const liveCategory = {
        category_name: this.$t("liveCasino"),
        items: liveGames,
      };

      const jackpotCategory = {
        category_name: "Jackpot",
        items: jackpotGames,
      };

      const scratchCategory = {
        category_name: this.$t("scratch"),
        items: scratchGames,
      };

      const tableGamesCategory = {
        category_name: this.$t("tableGames"),
        id_tipo: "tg",
        items: tableGames,
      };

      // const baccaratCategory = {
      //   category_name: "Baccarat",
      //   items: baccaratGames,
      // };

      // const blackjackCategory = {
      //   category_name: "Blackjack",
      //   items: blackjackGames,
      // };

      // const rouletteCategory = {
      //   category_name: this.$t("roulette"),
      //   items: rouletteGames,
      // };

      // const outrosCategory = {
      //   category_name: "Outros",
      //   items: outrosGames,
      // };

      this.games = [
        slotCategory,
        liveCategory,
        jackpotCategory,
        scratchCategory,
        tableGamesCategory,
        // baccaratCategory,
        // blackjackCategory,
        // rouletteCategory,
        // outrosCategory,
      ].filter((category) => category.items.length > 0);

      localStorage.setItem("hasSpaceman", this.showSpaceman);
      this.$store.commit("setDataCasinoGamesCategories", this.games);
    },
    // Rota para página do liveCasino ou de listagem de jogos da categoria selecionada
    goGamesCategory(category, seeAll) {
      // Funciona somente para os botões de "Ver todos" nas categorias
      if (seeAll) {
        this.$router.push({
          path: `/casino/listGamesCategories/${category}`,
          hash: "#scrollTop",
        });
      }
    },
    clearable() {
      this.gameSelected = null;
    },
  },
  watch: {
    games(val) {
      this.gamesLoaded = !!val;
    },
    $route(val) {
      // Após filtrar jogo com gameSearch, se voltar para home (cassino)
      // filtra novamente todos as categorias
      if (!val.query.gameSearch) {
        this.search = "";
        // Monta swiper novamente após voltar para home depois de filtrar jogos
        // pelo gameSearch
        mountCoverflowSwiper();
        this.getGameList;
      }

      if (val.name == "casino") {
        this.search = "";
      } else if (val.name == "casinoSpaceman") {
        this.search = val.query.gameSearch;

        // Caso seja clicado no Spaceman no leftMenu sem estar logado e já estiver
        // na pagina de casino, terá que fazer login e assim ser redirecionado para o jogo
        this.gameClicked(this.spaceman, false);
      }
    },
  },
  computed: {
    isIOS() {
      return ["iPad", "iPhone", "iPod"].indexOf(navigator.platform) >= 0;
    },
    casino() {
      return this.$store.state.operators.casino;
    },
    showSpaceman() {
      if (!this.spacemanExists) {
        return false;
      }

      if (this.search) {
        return this.spaceman.nome_jogo
          .toLowerCase()
          .includes(this.search.toLowerCase());
      }

      return true;
    },
    skeletonPerCol() {
      const breakpoint = this.$vuetify.breakpoint.name;

      if (breakpoint == "xs") {
        return 2;
      } else if (breakpoint == "md") {
        return 3;
      } else if (breakpoint == "lg") {
        return 4;
      } else if (breakpoint == "xl") {
        return 6;
      }

      return 6;
    },
    getGameList() {
      // Monta swiper novamente após voltar para home depois de mudar idioma na view de listagem de jogos
      mountCoverflowSwiper();

      if (this.search) {
        return this.games.map((category) => {
          let items = [];

          for (let game of category.items) {
            if (
              game.nome_jogo.toLowerCase().includes(this.search.toLowerCase())
            ) {
              items.push(game);
            }
          }

          return { ...category, items };
        });
      }

      return this.games;
    },
  },
};
</script>
<style scoped>
@keyframes rotation {
  0% {
    transform: rotate(0deg);
    top: -70px;
    left: -200px;
  }
  25% {
    top: -50px;
  }
  50% {
    top: -30px;
  }
  75% {
    top: -10px;
    left: -50px;
  }
  100% {
    transform: rotate(180deg) scale(1);
    left: 0px;
  }
}
.dice {
  animation-name: rotation;
  animation-duration: 0.4s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
}
/* Caso tenha um height no skeleton, esse código abaixo fará com que o skeleton fique
100% da altura definida  */
.v-skeleton-loader.v-skeleton-loader--is-loading >>> .v-skeleton-loader__image {
  height: 100%;
}
.swiper {
  width: 100%;
}
.swiper-slide {
  background-position: center;
  background-size: cover;
  display: flex;
  justify-content: center;
  margin: 0 10px;
}
.swiper-button-prev::after,
.swiper-rtl .swiper-button-next::after,
.swiper-button-next::after,
.swiper-rtl .swiper-button-prev::after {
  content: "";
}
.radialGradientRight,
.radialGradientLeft {
  position: absolute;
  width: 300px;
  height: 300px;
  background: radial-gradient(
    circle,
    var(--v-primary-base) 0%,
    var(--v-colorDominant-base) 100%
  );
  filter: blur(150px);
}
.radialGradientRight {
  right: -100px;
  top: 900px;
}
.radialGradientLeft {
  left: -100px;
  top: 1600px;
}
.videoBlur,
.videoBlurMobile {
  position: relative;
}
.videoBlur::after,
.videoBlurMobile::after {
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(69, 69, 69, 0) 80%,
    rgb(0, 0, 0) 92%,
    rgba(69, 69, 69, 0) 98%
  );
}
.videoBlur::after {
  bottom: -30px;
}
.videoBlurMobile::after {
  bottom: -20px;
}
</style>
